import PropTypes from 'prop-types';

/**
 * @memberof module:react/propTypes
 * @typedef {Object} Asset
 * @prop {string} id Asset id
 * @prop {boolean} isFavorite True if asset is marked as a favorite
 * @prop {string} mosObjectId mosObjectId which is populated if the asset is a mos object
 * @prop {string} abstract Abstract text
 * @prop {string} title Asset title
 */
export default PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isFavorite: PropTypes.bool,
  mosObjectId: PropTypes.string,
  abstract: PropTypes.string,
  title: PropTypes.string
});



// WEBPACK FOOTER //
// ./app/propTypes/asset.js